
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PeriodicClosingGrid extends Serenity.EntityGrid<PeriodicClosingRow, any> {
        protected getColumnsKey() { return 'Finance.PeriodicClosing'; }
        protected getDialogType() { return PeriodicClosingDialog; }
        protected getIdProperty() { return PeriodicClosingRow.idProperty; }
        protected getInsertPermission() { return PeriodicClosingRow.insertPermission; }
        protected getLocalTextPrefix() { return PeriodicClosingRow.localTextPrefix; }
        protected getService() { return PeriodicClosingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(57);
            this.editItem(<PeriodicClosingRow>{
                VoucherNo: voucherNo,
                TransDate: now.toDateString(),
                VoucherTypeId: 57,

            });
        }
    }
}